import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const ParagraphLivechart = ({ entity }) => {
  return (
    <Container className="ParagraphLivechart" small>
      <div className="ParagraphLivechart__wrapper">
        <object className="livechart" data={entity.getIn(['field_link', 0, 'uri'])} type="image/svg+xml" />
      </div>
    </Container>
  );
};

export default ParagraphLivechart;
